import React, { useRef } from 'react';
import Input from '../common/Input';

// Picker nativo do browser ancorado ao swatch visual. Implementação anterior
// criava o <input type="color"> com `document.createElement` + `.click()` —
// sem ancoragem, o painel nativo aparecia colado no topo da viewport.
// Aqui o input vive dentro do container do swatch (absolute, opacity 0), então
// o popup nativo posiciona próximo ao trigger.
const ColorPicker = ({ label, value, onChange, helpText = '' }) => {
  const inputRef = useRef(null);

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-app-text">
        {label}
      </label>
      <div className="flex gap-3 items-center">
        <div className="relative w-16 h-16">
          <div
            className="w-16 h-16 rounded-lg border-2 border-gray-300 shadow-md cursor-pointer hover:scale-105 transition-transform"
            style={{ backgroundColor: value }}
            onClick={() => inputRef.current?.click()}
          />
          <input
            ref={inputRef}
            type="color"
            value={value || '#000000'}
            onChange={(e) => onChange(e.target.value)}
            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
            aria-label={`Selecionar cor: ${label}`}
          />
        </div>
        <div className="flex-1">
          <Input
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder="#000000"
            className="font-mono text-sm"
          />
          {helpText && (
            <p className="text-xs text-app-text-secondary mt-1">{helpText}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ColorPicker;
